import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'scss/banner.scss';
import 'scss/toggle.scss';

export default class Toggle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            on: false
        };
    }

    toggle = () => {
        const value = !this.state.on;
        this.setState({on: value});
        this.props.onChange(value);
    };

    render() {
        const {on} = this.state;

        return (
            <div
                className="rate-creators-toggle"
                onClick={this.toggle}
            >
                <i className={classNames('rate-creators-icon', 'rate-creators-icon-small', {'rate-creators-icon-blue': on})} />
                <div className={classNames('toggle', {'toggle-on': on})} />
            </div>
        );
    }
}

Toggle.propTypes = {
    onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/toggle.js